module.exports = __webpack_public_path__ + "static/media/FSS.57e24389.png";